import { reportFunnelEvent, type FunnelEventPayload } from './promo';

export type FunnelEventName =
  | 'checkout_started'
  | 'checkout_cancelled'
  | 'checkout_failed'
  | 'purchase_verified'
  | 'trial_started'
  | 'paywall_view'
  | 'first_benefit_used';

export interface FunnelEventData extends Omit<FunnelEventPayload, 'event'> {
  /** Diagnose-Grund, z.B. „offer_missing“, ohne Store-Belege oder Nutzerinhalte. */
  reason?: string;
}

export function trackFunnel(event: FunnelEventName, data: FunnelEventData = {}): void {
  // A1 korreliert Client-Bestätigungen über attempt_id. Alte Aufrufstellen
  // ohne Versuch bleiben stumm; Trials zählt weiterhin der Server.
  if (event === 'trial_started' || (event === 'purchase_verified' && !data.meta?.attempt_id)) return;
  const { reason, ...payload } = data;
  try {
    void reportFunnelEvent({
      ...payload,
      event,
      meta: reason ? { ...payload.meta, reason } : payload.meta,
    }).catch(() => undefined);
  } catch {
    // Messfehler dürfen den Kaufpfad nicht unterbrechen.
  }
}
